import React from 'react'
import PropTypes from 'prop-types'
import {
  DataTable, Table, TableBody, TableCell, TableContainer,
  TableHead, TableHeader, TableRow, TableToolbar, TableToolbarContent,
  TableToolbarSearch, Button
} from '@carbon/react';
import { useSorting } from '../../modules/hooks/sorting';

const HdopTable = props => {
  const { data } = props

  const headerData = [
    { header: 'ID del Dispositivo', key: 'device_id' },
    { header: 'Fecha', key: 'currTime' },
    { header: 'Grupo', key: 'group' },
    { header: 'Patente', key: 'truckPatent' },
    { header: 'Operador', key: 'curr_operador' },
    { header: 'Geocerca', key: 'geofence_name' },
    { header: 'Hdop', key: 'hdop' },
  ];  

  const convertToCSV = (data) => {
    // Define the mapping between the table headers and the object keys in `data`
    const headerMapping = {
      device_id: 'ID del Dispositivo',
      currTime: 'Fecha',
      group: 'Grupo',
      truckPatent: 'Patente',
      curr_operador: 'Operador',
      geofence_name: 'Geocerca',
      hdop: 'Hdop'
    };

    if (data.length === 0) {
      return '';
    }

    const headers = Object.values(headerMapping).join(',') + '\n';
    const rows = data.map(row => {
      return Object.keys(headerMapping).map(key => {
        let value = row[key];
    
        // Handle null or undefined values
        if (value === null || value === undefined) {
          value = ''; // Replace null/undefined with an empty string
        } else if (!isNaN(value) && typeof value === 'number' && value.toString().includes('.')) {
          // If it's a number with a dot, replace the dot with a comma
          value = value.toString().replace('.', ',');
        }
    
        return `"${value}"`; // Apply text formatting to all fields
      }).join(',');
    }).join('\n');

    return headers + rows;
  };

  const downloadCSV = (csvContent, fileName = 'download.csv') => {
    // Create a Blob with the CSV content
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    // Create a hidden link element
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);

    // Append link to the body, click it, and then remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = () => {
    const csv = convertToCSV(data);

    downloadCSV(csv, 'Hdop.csv');
  };

  
  const { rows, headers } = useSorting(data, headerData);

  const Default = () => <DataTable rows={rows} headers={headers}>
    {({
      rows,
      headers,
      getHeaderProps,
      getRowProps,
      getTableProps,
      getTableContainerProps,
      onInputChange,
      sortBy
    }) => <TableContainer {...getTableContainerProps()}>
        <TableToolbar>
          <TableToolbarContent>
            {/* pass in `onInputChange` change here to make filtering work */}
            <TableToolbarSearch onChange={onInputChange} />
            <Button onClick={handleDownload} >Descargar</Button>
          </TableToolbarContent>
        </TableToolbar>
        <Table {...getTableProps()} aria-label="sample table">
          <TableHead>
            <TableRow>
              {headers.map((header, i) => <TableHeader
                key={i}
                sortDirection={headerData[i]?.sortDirection ?? "NONE"}
                {...getHeaderProps({
                  header,
                  isSortable: (headerData[i]?.sortDirection ?? "NONE") !== "NONE",
                  onClick: (_, sortState) => sortBy(sortState.sortHeaderKey)
                })}>
                {header.header}
              </TableHeader>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => <React.Fragment key={row.id}>
              <TableRow {...getRowProps({
                row
              })}>
                {row.cells.map(cell => <TableCell key={cell.id}>{cell.value}</TableCell>)}
              </TableRow>
            </React.Fragment>)}
          </TableBody>
        </Table>
      </TableContainer>}
  </DataTable>;

  return (
    <Default />
  )
}

HdopTable.propTypes = {
  data: PropTypes.array
}

export default HdopTable;